import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface PageToolbarProps {
  title?: string;
  onBack?: () => void;
  actions?: ReactNode;
}

const PageToolbar = ({ title, onBack, actions }: PageToolbarProps) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={1.5}
      mb={2}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {onBack ? (
          <Button
            startIcon={<ArrowBackRoundedIcon />}
            onClick={onBack}
            variant="text"
            sx={{
              px: 1.2,
              minWidth: "auto",
              color: "text.secondary",
              borderRadius: 10,
              "&:hover": {
                color: "primary.main",
                backgroundColor: "action.hover",
              },
            }}
          >
            Voltar
          </Button>
        ) : null}

        {title ? (
          <Typography variant="h6" fontWeight={700} color="text.primary">
            {title}
          </Typography>
        ) : null}
      </Stack>

      {actions ? (
        <Stack direction="row" spacing={1.2} flexWrap="wrap">
          {actions}
        </Stack>
      ) : null}
    </Box>
  );
};

export default PageToolbar;
